<template>
  <div class="question">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Question",
};
</script>

<style scoped>
/*  CSS Da pergunta de ratting  */
@import url("../assets/css/ratting.css");

div.question {
  position: relative;
  top: 30px;
}

label.question-label {
  display: block !important;
  color: #e31837;
}

.label_question {
  text-align: center;
  font-size: 1.8rem;
  position: relative;
  top: 8px;
}

.range_box_wrapper {
  max-width: 600px;
  margin: 0 auto;
  margin-top: 30px;
  text-align: center;
}

.range_box_wrapper > span {
  font-size: 40px;
  margin-bottom: 10px;
  color: #006491;
}

.range_question_type_box > button {
  display: block;
}

.store_select {
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.store_select div {
  width: 100%;
}

.store_select div label {
  font-size: 16px;
  color: #006491;
}

.store_select div select {
  height: 50px;
  border: 2px solid #006491;
  line-height: 2.4;
}

@media screen and (max-width: 768px) {
  .label_question {
    font-size: 25px;
  }

  div.question {
    position: relative;
    top: 0px;
    padding-bottom: 40px;
  }
}

.inputBox {
  margin: 10px 0;
}

@media screen and (max-width: 580px) {
  .label_question {
    font-size: 23px;
  }

  .range_box_wrapper {
    max-width: 600px;
    margin: 0 auto;
    margin-top: 0px;
    text-align: center;
  }
}

@media screen and (max-width: 380px) {
  .label_question {
    font-size: 20px;
  }
}
</style>
